module.exports = __webpack_public_path__ + "static/MobileAppLearning-467fe74d205186c145b509e4959f4106.png";